import { getUser } from "../User/userApi"
import { getDiscount } from "./discountApi"
import {} from "../types"
import { ProductDiscount } from "./discountTypes"

export async function getDiscountsOfUser(
    userId: string,
    accessToken?: string
): Promise<ProductDiscount> {
    try {
        const user = await getUser(userId, accessToken)
        const discounts = await Promise.all(
            user.data?.discounts?.map((d) => getDiscount(d, accessToken)) ?? []
        )
        const productDiscounts: ProductDiscount = discounts.reduce(
            (prevValue, currentDiscount) => {
                return {
                    ...currentDiscount.data?.discounts,
                    ...prevValue,
                }
            },
            {}
        )

        const userCustomDiscount = user.data?.customDiscount ?? {}

        return {
            ...productDiscounts,
            ...userCustomDiscount,
        }
    } catch (err) {
        // @ts-ignore
        throw new Error(err)
    }
}
